export default __webpack_public_path__ + "assets/7b9776076d5fceef4993b55c9383dedd.gif";